import './bootstrap';

/* opening calendar when click */
document.querySelectorAll('input[type="date"]').forEach(function(input){input.addEventListener('click',function(e){this.showPicker && this.showPicker();});});